import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import { Process, ProcessSearch } from '@app/models/item/process';

@Injectable({
  providedIn: 'root',
})
export class ProcessesProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/processes';

  public searchProcesses(searchCriteria: ProcessSearch): Observable<ApiResponse<Process[]>> {
    return this.httpClient.post<ApiResponse<Process[]>>(`${this.baseUrl}/search`, searchCriteria);
  }
}
